import { createContext } from 'react';

const DocumentModifiersContext = createContext({
  setCfi: () => {},
  setPercentageScrolled: () => {},
  setState: () => {},
  setFrame: () => {},
  removeFrame: () => {},
});

export default DocumentModifiersContext;
